document.addEventListener('DOMContentLoaded', function () {
  const downloadButtons = document.querySelectorAll('.gcc-catalogs-grid__download');

  if (!downloadButtons.length) return;

  downloadButtons.forEach(function (button) {
    const textNode = button.querySelector('.gcc-catalogs-grid__download-text');

    function setState(state) {
      const defaultLabel = button.getAttribute('data-label-default') || 'Descargar PDF';
      const loadingLabel = button.getAttribute('data-label-loading') || 'Descargando...';
      const successLabel = button.getAttribute('data-label-success') || 'Descargado';
      const errorLabel = button.getAttribute('data-label-error') || 'Error al descargar';

      button.classList.remove(
        'is-loading',
        'is-success',
        'is-error'
      );

      if (state === 'loading') {
        button.classList.add('is-loading');
        if (textNode) textNode.textContent = loadingLabel;
      } else if (state === 'success') {
        button.classList.add('is-success');
        if (textNode) textNode.textContent = successLabel;
      } else if (state === 'error') {
        button.classList.add('is-error');
        if (textNode) textNode.textContent = errorLabel;
      } else {
        if (textNode) textNode.textContent = defaultLabel;
      }
    }

    button.addEventListener('click', async function () {
      const fileUrl = button.getAttribute('data-download-url');
      const fileName = button.getAttribute('data-download-name') || 'catalogo.pdf';

      if (!fileUrl || button.classList.contains('is-loading')) return;

      setState('loading');
      button.disabled = true;

      try {
        const response = await fetch(fileUrl, { mode: 'cors' });
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const tempLink = document.createElement('a');
        tempLink.href = blobUrl;
        tempLink.download = fileName;
        document.body.appendChild(tempLink);
        tempLink.click();
        tempLink.remove();

        window.URL.revokeObjectURL(blobUrl);

        setState('success');
      } catch (error) {
        setState('error');
        window.open(fileUrl, '_blank');
      }

      window.setTimeout(function () {
        button.disabled = false;
        setState('default');
      }, 1800);
    });
  });
});